import actions from 'actions'

const defaultState = {
  isSaving: false,
}

export default function eventgroupDetailsPage(state = defaultState, action) {
  switch (action.type) {
    case actions.ENTITIES_EVENT_GROUP.REQUEST :
      return {
        ...state,
        isSaving: true,
      }
    case actions.ENTITIES_EVENT_GROUP.SUCCESS :
      return {
        ...state,
        isSaving: false,
      }
    case actions.ENTITIES_EVENT_GROUP.FAILURE :
      return {
        ...state,
        isSaving: false,
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/pages/eventgroup-details-page/eventgroup-details-page.js
 **/